(() => {
  if (customElements.get('pdp-gallery')) return;

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this._slides = [...this.querySelectorAll('[data-wt-slide]')];
      this._thumbs = [...this.querySelectorAll('[data-wt-index]')];
      this._dialog = this.querySelector('dialog');
      this._index = Math.max(0, this._slides.findIndex(slide => !slide.hidden));
      this.querySelectorAll('[data-wt-controls]').forEach(control => { control.hidden = false; });

      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-wt-index]');
        if (thumb) this.show(Number(thumb.dataset.wtIndex));
        if (event.target.closest('[data-wt-prev]')) this.show(this._index - 1);
        if (event.target.closest('[data-wt-next]')) this.show(this._index + 1);
        if (event.target.closest('[data-wt-close]')) this._dialog.close();
        if (event.target.closest('[data-wt-zoom]')) this.zoom();
        const opener = event.target.closest('[data-wt-open]');
        if (opener && typeof this._dialog.showModal === 'function') {
          event.preventDefault();
          this.open(opener);
        }
      }, options);

      this.addEventListener('keydown', event => {
        if (this._dialog.open || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this._index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, options);

      const stage = this.querySelector('.wt0916p-gallery__stage');
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') this._touchStart = { x: event.clientX, y: event.clientY };
      }, options);
      stage.addEventListener('pointerup', event => {
        if (!this._touchStart || event.pointerType !== 'touch') return;
        const dx = event.clientX - this._touchStart.x;
        const dy = event.clientY - this._touchStart.y;
        this._touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.show(this._index + (dx < 0 ? 1 : -1));
        }
      }, options);
      stage.addEventListener('pointercancel', () => { this._touchStart = null; }, options);

      this._dialog.addEventListener('click', event => {
        if (event.target !== this._dialog) return;
        const rect = this._dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this._dialog.close();
      }, options);
      this._dialog.addEventListener('close', () => {
        if (this._opener?.isConnected) this._opener.focus({ preventScroll: true });
      }, options);
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
    }

    show(index) {
      this._index = (index + this._slides.length) % this._slides.length;
      this._slides.forEach((slide, position) => { slide.hidden = position !== this._index; });
      this._thumbs.forEach((thumb, position) => {
        if (position === this._index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.querySelector('[data-wt-counter]').textContent = this._index + 1;
      this.querySelector('[data-wt-status]').textContent = this._slides[this._index].getAttribute('aria-label');
    }

    zoom() {
      const frame = this.querySelector('[data-wt-image-frame]');
      this._zoomed = !this._zoomed;
      frame.style.width = this._zoomed ? `${this._baseImageWidth * 2}px` : '';
      const button = this.querySelector('[data-wt-zoom]');
      button.textContent = this._zoomed ? this.dataset.labelReset : this.dataset.labelZoom;
      button.setAttribute('aria-label', this._zoomed ? this.dataset.labelResetAria : this.dataset.labelZoomAria);
      if (!this._zoomed) this.querySelector('.wt0916p-gallery__dialog-body').scrollTo(0, 0);
    }

    open(opener) {
      this._opener = opener;
      const image = this.querySelector('[data-wt-dialog-image]');
      image.src = opener.href;
      this.querySelector('[data-wt-original]').href = opener.href;
      image.alt = opener.dataset.wtAlt || '';
      this.querySelector('[data-wt-dialog-caption]').textContent = image.alt;
      const frame = this.querySelector('[data-wt-image-frame]');
      frame.className = 'wt0916p-gallery__image-frame';
      if (/box-(front|back)/.test(opener.href)) frame.classList.add('wt0916p-gallery__image-frame--box');
      if (/sachet-front/.test(opener.href)) frame.classList.add('wt0916p-gallery__image-frame--sachet');
      frame.style.width = '';
      this._zoomed = false;
      this.querySelector('[data-wt-zoom]').textContent = this.dataset.labelZoom;
      this.querySelector('[data-wt-zoom]').setAttribute('aria-label', this.dataset.labelZoomAria);
      this._dialog.showModal();
      this._baseImageWidth = frame.getBoundingClientRect().width;
      this.querySelector('[data-wt-close]').focus();
    }
  }

  customElements.define('pdp-gallery', ProductGallery);
})();
